// key = namespace.subkey, z.B. 'hero.title'
export const translations = {
  en: {
    // Early Access Banner (minimal keys used on IR page)
    'earlyAccess.title': 'Coming soon: Pre-financing your EU CAP funding',
    'earlyAccess.subtitle': 'We are building a solution to make your CAP entitlements liquid before payout.',
    'earlyAccess.emailPlaceholder': 'E-mail',
    'earlyAccess.button': 'Notify me',
    'earlyAccess.submitting': 'Sending...',
    'earlyAccess.thankYou': 'Thank you – we will get back to you!',
    'earlyAccess.error': 'Error during signup. Please try again.',
    'payment.emailPlaceholder': 'your@email.com'
  },
  pt: {
    // Acesso antecipado (chaves mínimas)
    'earlyAccess.title': 'Em breve: Pré-financiamento da sua PAC (UE)',
    'earlyAccess.subtitle': 'Estamos a criar uma solução para tornar os seus direitos da PAC líquidos antes do pagamento.',
    'earlyAccess.emailPlaceholder': 'E-mail',
    'earlyAccess.button': 'Quero ser informado',
    'earlyAccess.submitting': 'A enviar...',
    'earlyAccess.thankYou': 'Obrigado – entraremos em contacto!',
    'earlyAccess.error': 'Erro ao registar. Por favor, tente novamente.',
    'payment.emailPlaceholder': 'o-seu@email.pt'
  },
  de: {
    // Homepage
    welcome: "Willkommen bei",
    subtitle: "Die KI-Plattform, die Ihr Unternehmen revolutioniert",
    startButton: "Jetzt starten",
    capabilities: "Was Centeo möglich macht:",
    liquidity: "Liquidität in 48 Stunden",
    partnership: "Faire Partnerschaft", 
    investment: "Attraktive Investition",
    
    // Hero Section
    heroTitle: "GAP-Förderung leicht gemacht",
    heroSubtitle: "Finden Sie in 3 Minuten die passenden EU-Förderprogramme für Ihren Betrieb.",
    heroSubtitleBold: "KI-basiert, schnell, zuverlässig.",
    
    // Stats
    statFunding: "Gefunden",
    statFarmers: "Landwirte", 
    statProcessing: "Bearbeitung",
    
    // Process
    processTitle: "So einfach geht's",
    step1Title: "Betrieb beschreiben",
    step1Text: "3 Minuten Fragebogen",
    step2Title: "KI analysiert", 
    step2Text: "Passende Programme finden",
    step3Title: "Ergebnisse erhalten",
    step3Text: "Sofort verfügbar",
    
    // Pricing
    pricingTitle: "Einmalige Analyse",
    pricingBenefit1: "Alle passenden EU-Programme",
    pricingBenefit2: "KI-basierte Analyse", 
    pricingBenefit3: "Sofortige Ergebnisse",
    pricingBenefit4: "Geld-zurück-Garantie",
    pricingButton: "🚀 Jetzt starten",
    
    // Form Header
    farmDataTitle: "Ihre GAP-Förderung finden",
    farmDataSubtitle: "Beantworten Sie ein paar Fragen zu Ihrem Betrieb und wir finden die passenden EU-Förderprogramme für Sie.",
    
    // Form
    yourResults: "Ihre maßgeschneiderten Förderprogramme",
    
    // Program fields
    fundingType: "Förderart",
    level: "Ebene", 
    targetGroup: "Zielgruppe",
    fundingVolume: "Fördervolumen",
    timeline: "Zeitplan",
    combinability: "Kombinierbarkeit",
    carrier: "Träger",
    
    // StartScreen
    startTitle: "Was ist Ihr heutiges Ziel?",
    annualButton: "Jährliche Prämien sichern",
    projectButton: "Neues Projekt finanzieren",
    
    // FarmDataForm
    projectTitle: "3-Fragen-Assistent für Ihr Projekt",
    q1: "Wo ist Ihr Betrieb?",
    country: "Land",
    region: "Region/Bundesland",
    q2: "Was ist Ihr Hauptbetriebszweig?",
    q2Options: ["Ackerbau", "Milchvieh", "Geflügel", "Weinbau", "Sonstiges"],
    q3: "Was ist Ihr wichtigstes Ziel?",
    q3Options: ["Investieren", "Nachhaltigkeit", "Digitalisierung"],
    submitButton: "Förderungen finden",
    select: "Bitte wählen",
    
    // Form fields
    'form.country': 'In welchem Land bewirtschaften Sie?',
    'form.farmType': 'Was für ein Betrieb ist es?',
    'form.farmSize': 'Wie groß ist Ihr Betrieb? (Hektar)',
    'form.minFunding': 'Mindest-Förderbetrag (€)',
    'form.age': 'Ihr Alter (für Junglandwirte-Programme)',
    'form.urgency': 'Wie dringend benötigen Sie die Förderung?',
    'form.interests': 'Wofür interessieren Sie sich? (Mehrfachauswahl)',
    'form.organic': 'Mein Betrieb ist bio-zertifiziert oder ich plane eine Umstellung',
    'form.findPrograms': 'Passende Förderprogramme finden',
    'form.selectCountry': 'Land auswählen',
    'form.selectFarmType': 'Betriebsart auswählen',
    'form.selectUrgency': 'Dringlichkeit wählen',
    
    // Farm types
    'farmType.dairy': 'Milchvieh',
    'farmType.crops': 'Ackerbau',
    'farmType.mixed': 'Gemischt',
    'farmType.organic': 'Bio-Betrieb',
    'farmType.livestock': 'Viehzucht',
    'farmType.other': 'Sonstiges',
    
    // Categories
    'category.innovation': 'Innovation',
    'category.sustainability': 'Nachhaltigkeit',
    'category.digital': 'Digitalisierung',
    'category.climate': 'Klimaschutz',
    'category.animalWelfare': 'Tierwohl',
    'category.energy': 'Energie',
    
    // Errors
    'error.countryRequired': 'Land ist erforderlich',
    'error.farmTypeRequired': 'Betriebsart ist erforderlich',
    'error.farmSizeRequired': 'Betriebsgröße muss größer als 0 sein',
    
    // Navigation
    backToHome: "← Zurück zur Startseite",
    backToForm: "← Zurück zur Eingabe",
    
    // Payment
    'payment.title': 'Fast geschafft!',
    'payment.subtitle': 'Bezahlen Sie einmalig 9,90€ und erhalten Sie sofort Ihre personalisierten Förderprogramme.',
    'payment.amount': '9,90€',
    'payment.buttonText': 'Jetzt für 9,90€ bezahlen',
    'payment.emailPlaceholder': 'ihre@email.de',
    'payment.analysisFor': 'Ihre Analyse für',
    'payment.country': 'Land',
    'payment.farmType': 'Betriebsart',
    'payment.goal': 'Ziel',
    'payment.region': 'Region',
    'payment.serviceName': 'Centeo Förderanalyse',
    'payment.total': 'Gesamt',
    'payment.whatYouGet': 'Das erhalten Sie',
    'payment.benefit1': 'Personalisierte Förderprogramme für Ihren Betrieb',
    'payment.benefit2': 'Geschätzte Förderbeträge und Erfolgsquoten',
    'payment.benefit3': 'Deadlines und erforderliche Dokumente',
    'payment.benefit4': '30 Tage Zufriedenheitsgarantie',
    'payment.processing': 'Wird verarbeitet...',
    'payment.securityInfo': '🔒 Sichere Zahlung via Stripe • 💳 Alle Karten akzeptiert • 🛡️ SSL-verschlüsselt',
    'payment.backButton': 'Zurück zur Eingabe',
    
    // Early Access Banner
    'earlyAccess.title': 'Bald verfügbar: Vorfinanzierung eurer EU-Agrarförderung',
    'earlyAccess.subtitle': 'Wir arbeiten an einer Lösung, mit der ihr eure Förderansprüche schon vor Auszahlung liquid machen könnt.',
    'earlyAccess.emailPlaceholder': 'E-Mail',
    'earlyAccess.button': 'Informieren',
    'earlyAccess.submitting': '...',
    'earlyAccess.thankYou': 'Vielen Dank – wir melden uns!',
    'earlyAccess.error': 'Fehler bei der Anmeldung. Bitte versuchen Sie es erneut.',
    
    // Program Filter
    'filter.title': '🔍 Förderprogramme finden',
    'filter.country': 'Land:',
    'filter.allCountries': 'Alle Länder',
    'filter.region': 'Region:',
    'filter.allRegions': 'Alle Regionen',
    'filter.farmType': 'Betriebsart:',
    'filter.allFarmTypes': 'Alle Betriebsarten',
    'filter.farmSize': 'Betriebsgröße (Hektar):',
    'filter.farmSizePlaceholder': 'z.B. 100',
    'filter.categories': 'Kategorien:',
    'filter.minFunding': 'Mindest-Förderung (€):',
    'filter.minFundingPlaceholder': 'z.B. 10000',
    'filter.searchButton': '🔍 Programme suchen',
    'filter.searching': '🔍 Suche läuft...',
    'filter.error': '❌ Fehler:',
    
    // Enhanced Filter & Scoring (NEW) - Deutsche Übersetzungen
    'filter.searchPlaceholder': 'Intelligente Suche (mit Fuzzy-Matching)...',
    'filter.relevance': 'Relevanz',
    'filter.funding': 'Förderhöhe',
    'filter.deadline': 'Deadline',
    'filter.score': 'Score',
    'filter.fundingRange': 'Fördersummen-Bereich',
    'filter.minRelevance': 'Mindest-Relevanz',
    'filter.reset': '🔄 Zurücksetzen',
    'filter.advanced': '🔧 Erweiterte Filter',
    
    // Results
    'results.title': 'Ihre optimierten Förderprogramme',
    'results.subtitle': 'Programme mit intelligentem Scoring',
    'results.averageRelevance': '⭐ Ø {score}% Relevanz',
    'results.highRelevance': '🎯 {count} hochrelevant',
    'results.goodRelevance': '✅ {count} geeignet',
    'results.noResults': 'Keine Ergebnisse gefunden',
    'results.noResultsText': 'Keine Programme entsprechen den aktuellen Filterkriterien. Versuchen Sie, die Filter zu lockern oder zurückzusetzen.',
    
    // Program Card
    'card.topMatch': 'Top-Match',
    'card.highlyRecommended': 'Hochempfohlen',
    'card.verysuitable': 'Sehr geeignet',
    'card.suitable': 'Geeignet',
    'card.conditionally': 'Bedingt geeignet',
    'card.lesssuitable': 'Wenig geeignet',
    'card.relevance': 'Relevanz',
    'card.effort': 'Aufwand',
    'card.benefit': 'Nutzen',
    'card.analysis': 'Aufwand vs. Nutzen Analyse',
    'card.funding': 'Fördervolumen',
    'card.rating.optimal': 'Optimal',
    'card.rating.good': 'Gut',
    'card.rating.check': 'Prüfen',
    'card.effort.low': 'Niedrig',
    'card.effort.medium': 'Mittel',
    'card.effort.high': 'Hoch',
    'card.showDetails': 'Details anzeigen',
    'card.hideDetails': 'Details ausblenden',
    'card.scoreBreakdown': 'Score-Aufschlüsselung',
    'card.deadline': 'Deadline:',
    'card.tags': 'Tags:',
    'card.urgent': '(Dringend!)',
    'card.applyNow': 'Jetzt beantragen!',
    'card.viewDetails': 'Details ansehen',
    'card.learnMore': 'Mehr erfahren',
    
    // Funding Ranges
    'funding.over100k': 'Über 100.000€',
    'funding.50to100k': '50.000€ - 100.000€',
    'funding.25to50k': '25.000€ - 50.000€',
    'funding.10to25k': '10.000€ - 25.000€',
    'funding.under10k': 'Unter 10.000€',
    'funding.allRanges': 'Alle Bereiche',
    'funding.notSpecified': 'Nicht spezifiziert',
    'funding.onRequest': 'Auf Anfrage',
    'funding.up_to': 'bis {amount}€',
    'funding.from': 'ab {amount}€',
    
    // Loading & Errors
    'loading.searching': 'Intelligente Programmsuche läuft...',
    'loading.analyzing': 'Analysiere Ihre Daten mit erweitertem Scoring-System',
    'error.loadingPrograms': 'Fehler beim Laden der Programme',
    'error.tryAgain': 'Erneut versuchen',
    
    // New Layout Elements
    'results.topRecommendations': 'Top-Empfehlungen für Sie',
    'results.allPrograms': 'Alle Programme',
    'results.foundPrograms': 'Gefundene Programme',
    'results.programsFound': 'Programme gefunden',
    'results.sortedByRelevance': 'Sortiert nach Relevanz für Ihren Betrieb',
    'results.highlyRelevant': 'Hoch relevant',
    'results.stillAvailable': 'Noch verfügbar',
    'results.avgRelevance': 'Ø Relevanz',
    'card.topMatch1': '#1 Top-Match',
    'card.veryGood2': '#2 Sehr gut',
    'card.recommendation3': '#3 Empfehlung',
    
    // Enhanced Program Card
    'card.pages': 'Seiten',
    'card.documents': 'Dokumente',  
    'card.documents_count': 'Stück',
    'card.form': 'Formular',
    'card.complexity.simple': 'Einfach',
    'card.complexity.medium': 'Mittel', 
    'card.complexity.complex': 'Komplex',
    'card.relevance.perfect': '⭐ Perfekt relevant',
    'card.relevance.high': '⭐ Sehr relevant', 
    'card.relevance.good': '✓ Relevant',
    'card.relevance.limited': '⚠️ Bedingt relevant',
    'card.of': 'von', // für "11 von 22"
    'card.optimal': 'Optimal',
    'card.good': 'Gut', 
    'card.check': 'Prüfen',

    // Ampel (Traffic Light) System
    'ampel.title': '🚦 Aufwand-Ampel',
    'ampel.filterAll': 'Alle',
    'ampel.filterGreen': 'Schnell',
    'ampel.filterYellow': 'Mittel',
    'ampel.filterOrange': 'Aufwändig',
    'ampel.filterRed': 'Komplex',
    'ampel.sortROI': 'Beste ROI ↓',
    'ampel.sortEffort': 'Wenigster Aufwand ↑',
    'ampel.sortDeadline': 'Dringendste ↑',
    'ampel.topRecommendations': 'TOP-Empfehlungen',
    'ampel.urgent': 'Dringend',
    'ampel.avgROI': 'Ø ROI',
    'ampel.quickStats': 'Schnellübersicht',
    'ampel.effortLow': 'Geringer Aufwand',
    'ampel.effortMedium': 'Mittlerer Aufwand',
    'ampel.effortHigh': 'Hoher Aufwand',
    'ampel.effortVeryHigh': 'Sehr hoher Aufwand',

    // PDF Export
    'pdf.title': 'CENTEO - Förderprogramm Details',
    'pdf.generatedOn': 'Generiert am',
    'pdf.evaluation': 'Bewertung',
    'pdf.relevanceScore': 'Relevanz-Score',
    'pdf.effort': 'Aufwand',
    'pdf.benefit': 'Nutzen',
    'pdf.basicInfo': 'Grundinformationen',
    'pdf.carrier': 'Träger',
    'pdf.level': 'Level',
    'pdf.type': 'Art',
    'pdf.farmTypes': 'Betriebstypen',
    'pdf.targetGroup': 'Zielgruppe',
    'pdf.financing': 'Finanzierung',
    'pdf.fundingVolume': 'Fördervolumen',
    'pdf.fundingRate': 'Fördersatz',
    'pdf.countries': 'Länder',
    'pdf.rating': 'Bewertung',
    'pdf.applicationEffort': 'Antragsaufwand',
    'pdf.form': 'Formular',
    'pdf.pages': 'Seiten',
    'pdf.documents': 'Dokumente',
    'pdf.pieces': 'Stück',
    'pdf.complexity': 'Komplexität',
    'pdf.simple': 'Einfach',
    'pdf.medium': 'Mittel',
    'pdf.complex': 'Komplex',
    'pdf.timeline': 'Zeitplan & Kombinationen',
    'pdf.deadline': 'Deadline',
    'pdf.endOf2025': 'Ende 2025',
    'pdf.ongoing': 'Laufend',
    'pdf.combinable': 'Kombinierbar',
    'pdf.programs': 'Programme',
    'pdf.combinability': 'Kombinierbarkeit',
    'pdf.moreInfo': 'Weitere Informationen',
    'pdf.footer': 'Erstellt mit CENTEO - Ihr Partner für EU-Agrarförderung',
    'pdf.disclaimer': 'Diese Informationen sind ohne Gewähr. Bitte prüfen Sie die aktuellen Bedingungen beim Träger.',
    'pdf.allFarmTypes': 'Alle Betriebstypen',
    'pdf.euWide': 'EU-weit',
    'pdf.grant': 'Zuschuss',
    'pdf.loan': 'Darlehen',
    'pdf.tax': 'Steuervorteil',
    'pdf.insurance': 'Versicherungshilfe',
    'pdf.inKind': 'Sachleistung',
    'pdf.farmers': 'Landwirte',
    'pdf.youth': 'Junglandwirte',
    'pdf.women': 'Frauen',
    'pdf.coop': 'Genossenschaften',
    'pdf.research': 'Forschung',
    'pdf.button': 'PDF',
    'pdf.generating': '⏳'
  },
  
  es: {
    // Homepage
    welcome: "Bienvenido a",
    subtitle: "La plataforma de IA que revoluciona tu empresa",
    startButton: "Empezar ahora",
    capabilities: "Lo que Centeo hace posible:",
    liquidity: "Liquidez en 48 horas",
    partnership: "Asociación justa",
    investment: "Inversión atractiva",
    
    // Hero Section
    heroTitle: "Financiación PAC fácil",
    heroSubtitle: "Encuentra en 3 minutos los programas de apoyo de la UE adecuados para tu explotación.",
    heroSubtitleBold: "Basado en IA, rápido, confiable.",
    
    // Stats
    statFunding: "Encontrado",
    statFarmers: "Agricultores",
    statProcessing: "Procesamiento",
    
    // Process
    processTitle: "Así de fácil es",
    step1Title: "Describir explotación",
    step1Text: "Cuestionario de 3 minutos",
    step2Title: "IA analiza",
    step2Text: "Encontrar programas adecuados",
    step3Title: "Recibir resultados", 
    step3Text: "Disponible inmediatamente",
    
    // Pricing
    pricingTitle: "Análisis único",
    pricingBenefit1: "Todos los programas UE adecuados",
    pricingBenefit2: "Análisis basado en IA",
    pricingBenefit3: "Resultados inmediatos", 
    pricingBenefit4: "Garantía de devolución",
    pricingButton: "🚀 Empezar ahora",
    
    // Form Header  
    farmDataTitle: "Encuentra tu financiación PAC",
    farmDataSubtitle: "Responde algunas preguntas sobre tu explotación y encontraremos los programas de apoyo de la UE adecuados para ti.",
    
    // Form
    yourResults: "Tus programas de financiación personalizados",
    
    // StartScreen
    startTitle: "¿Cuál es su objetivo hoy?",
    annualButton: "Asegurar las primas anuales",
    projectButton: "Financiar un nuevo proyecto",
    
    // FarmDataForm
    projectTitle: "Asistente de 3 preguntas para su proyecto",
    q1: "¿Dónde está su explotación?",
    country: "País",
    region: "Región/Estado",
    q2: "¿Cuál es su sector principal?",
    q2Options: ["Cultivos extensivos", "Ganado lechero", "Avicultura", "Viticultura", "Otro"],
    q3: "¿Cuál es su objetivo más importante?",
    q3Options: ["Invertir y crecer", "Ser más sostenible", "Digitalizar"],
    submitButton: "Encontrar financiación",
    select: "Seleccione",
    
    // Form fields
    'form.country': '¿En qué país gestionas tu explotación?',
    'form.farmType': '¿Qué tipo de explotación es?',
    'form.farmSize': '¿Qué tamaño tiene tu explotación? (hectáreas)',
    'form.minFunding': 'Cantidad mínima de financiación (€)',
    'form.age': 'Tu edad (para programas de jóvenes agricultores)',
    'form.urgency': '¿Qué tan urgente necesitas la financiación?',
    'form.interests': '¿Qué te interesa? (Selección múltiple)',
    'form.organic': 'Mi explotación está certificada ecológica o planeo convertirla',
    'form.findPrograms': 'Encontrar programas de apoyo adecuados',
    'form.selectCountry': 'Seleccionar país',
    'form.selectFarmType': 'Seleccionar tipo de explotación',
    'form.selectUrgency': 'Seleccionar urgencia',
    
    // Farm types
    'farmType.dairy': 'Lácteo',
    'farmType.crops': 'Cultivos',
    'farmType.mixed': 'Mixto',
    'farmType.organic': 'Ecológico',
    'farmType.livestock': 'Ganadería',
    'farmType.other': 'Otros',
    
    // Categories
    'category.innovation': 'Innovación',
    'category.sustainability': 'Sostenibilidad',
    'category.digital': 'Digitalización',
    'category.climate': 'Protección climática',
    'category.animalWelfare': 'Bienestar animal',
    'category.energy': 'Energía',
    
    // Errors
    'error.countryRequired': 'El país es obligatorio',
    'error.farmTypeRequired': 'El tipo de explotación es obligatorio',
    'error.farmSizeRequired': 'El tamaño de la explotación debe ser mayor que 0',
    
    // Navigation
    backToHome: "← Volver al inicio", 
    backToForm: "← Volver al formulario",
    
    // Payment
    'payment.title': '¡Casi listo!',
    'payment.subtitle': 'Paga una vez 9,90€ y recibe inmediatamente tus programas de financiación personalizados.',
    'payment.amount': '9,90€',
    'payment.buttonText': 'Pagar 9,90€ ahora',
    'payment.emailPlaceholder': 'tu@email.es',
    'payment.analysisFor': 'Tu análisis para',
    'payment.country': 'País',
    'payment.farmType': 'Tipo de explotación',
    'payment.goal': 'Objetivo',
    'payment.region': 'Región',
    'payment.serviceName': 'Análisis de Financiación Centeo',
    'payment.total': 'Total',
    'payment.whatYouGet': 'Lo que recibes',
    'payment.benefit1': 'Programas de financiación personalizados para tu explotación',
    'payment.benefit2': 'Importes estimados de financiación y tasas de éxito',
    'payment.benefit3': 'Plazos y documentos requeridos',
    'payment.benefit4': 'Garantía de satisfacción de 30 días',
    'payment.processing': 'Procesando...',
    'payment.securityInfo': '🔒 Pago seguro vía Stripe • 💳 Todas las tarjetas aceptadas • 🛡️ Cifrado SSL',
    'payment.backButton': 'Volver a la entrada',
    
    // Early Access Banner
    'earlyAccess.title': 'Próximamente: Prefinanciación de vuestras ayudas agrícolas UE',
    'earlyAccess.subtitle': 'Trabajamos en una solución para hacer líquidos vuestros derechos de ayuda antes del pago.',
    'earlyAccess.emailPlaceholder': 'E-Mail',
    'earlyAccess.button': 'Informar',
    'earlyAccess.submitting': '...',
    'earlyAccess.thankYou': '¡Gracias – nos pondremos en contacto!',
    'earlyAccess.error': 'Error en el registro. Por favor, inténtelo de nuevo.',
    
    // Program Filter
    'filter.title': '🔍 Encontrar programas de apoyo',
    'filter.country': 'País:',
    'filter.allCountries': 'Todos los países',
    'filter.region': 'Región:',
    'filter.allRegions': 'Todas las regiones',
    'filter.farmType': 'Tipo de explotación:',
    'filter.allFarmTypes': 'Todos los tipos',
    'filter.farmSize': 'Tamaño de explotación (hectáreas):',
    'filter.farmSizePlaceholder': 'ej. 100',
    'filter.categories': 'Categorías:',
    'filter.minFunding': 'Financiación mínima (€):',
    'filter.minFundingPlaceholder': 'ej. 10000',
    'filter.searchButton': '🔍 Buscar programas',
    'filter.searching': '🔍 Buscando...',
    'filter.error': '❌ Error:',
    
    // Enhanced Filter & Scoring (NEW)
    'filter.searchPlaceholder': 'Búsqueda inteligente (con corrección de errores)...',
    'filter.relevance': 'Relevancia',
    'filter.funding': 'Financiación',
    'filter.deadline': 'Fecha límite',
    'filter.score': 'Puntuación',
    'filter.fundingRange': 'Rango de financiación',
    'filter.minRelevance': 'Relevancia mínima',
    'filter.reset': '🔄 Restablecer',
    'filter.advanced': '🔧 Filtros avanzados',
    
    // Results
    'results.title': 'Tus programas de financiación optimizados',
    'results.subtitle': 'programas con puntuación inteligente',
    'results.averageRelevance': '⭐ Ø {score}% Relevancia',
    'results.highRelevance': '🎯 {count} muy relevantes',
    'results.goodRelevance': '✅ {count} adecuados',
    'results.noResults': 'No se encontraron resultados',
    'results.noResultsText': 'Ningún programa cumple con los criterios de filtro actuales. Intenta relajar los filtros o restablecerlos.',
    
    // Program Card
    'card.topMatch': 'Mejor coincidencia',
    'card.highlyRecommended': 'Muy recomendado',
    'card.verysuitable': 'Muy adecuado',
    'card.suitable': 'Adecuado',
    'card.conditionally': 'Condicionalmente adecuado',
    'card.lesssuitable': 'Menos adecuado',
    'card.relevance': 'Relevancia',
    'card.effort': 'Esfuerzo',
    'card.benefit': 'Beneficio',
    
    // PDF Export
    'pdf.title': 'CENTEO - Detalles del Programa de Financiación',
    'pdf.generatedOn': 'Generado el',
    'pdf.evaluation': 'Evaluación',
    'pdf.relevanceScore': 'Puntuación de Relevancia',
    'pdf.effort': 'Esfuerzo',
    'pdf.benefit': 'Beneficio',
    'pdf.basicInfo': 'Información Básica',
    'pdf.carrier': 'Organismo',
    'pdf.level': 'Nivel',
    'pdf.type': 'Tipo',
    'pdf.farmTypes': 'Tipos de Explotación',
    'pdf.targetGroup': 'Grupo Objetivo',
    'pdf.financing': 'Financiación',
    'pdf.fundingVolume': 'Volumen de Financiación',
    'pdf.fundingRate': 'Tasa de Financiación',
    'pdf.countries': 'Países',
    'pdf.rating': 'Valoración',
    'pdf.applicationEffort': 'Esfuerzo de Solicitud',
    'pdf.form': 'Formulario',
    'pdf.pages': 'páginas',
    'pdf.documents': 'Documentos',
    'pdf.pieces': 'piezas',
    'pdf.complexity': 'Complejidad',
    'pdf.simple': 'Simple',
    'pdf.medium': 'Medio',
    'pdf.complex': 'Complejo',
    'pdf.timeline': 'Cronograma y Combinaciones',
    'pdf.deadline': 'Fecha límite',
    'pdf.endOf2025': 'Fin de 2025',
    'pdf.ongoing': 'En curso',
    'pdf.combinable': 'Combinable',
    'pdf.programs': 'programas',
    'pdf.combinability': 'Combinabilidad',
    'pdf.moreInfo': 'Más Información',
    'pdf.footer': 'Creado con CENTEO - Su socio para la financiación agrícola de la UE',
    'pdf.disclaimer': 'Esta información es sin garantía. Por favor, verifique las condiciones actuales con el organismo.',
    'pdf.allFarmTypes': 'Todos los tipos de explotación',
    'pdf.euWide': 'En toda la UE',
    'pdf.grant': 'Subvención',
    'pdf.loan': 'Préstamo',
    'pdf.tax': 'Ventaja fiscal',
    'pdf.insurance': 'Ayuda de seguro',
    'pdf.inKind': 'En especie',
    'pdf.farmers': 'Agricultores',
    'pdf.youth': 'Jóvenes agricultores',
    'pdf.women': 'Mujeres',
    'pdf.coop': 'Cooperativas',
    'pdf.research': 'Investigación',
    'pdf.button': 'PDF',
    'pdf.generating': '⏳',
    'card.analysis': 'Análisis Esfuerzo vs. Beneficio',
    'card.funding': 'Volumen de financiación',
    'card.rating.optimal': 'Óptimo',
    'card.rating.good': 'Bueno',
    'card.rating.check': 'Revisar',
    'card.effort.low': 'Bajo',
    'card.effort.medium': 'Medio',
    'card.effort.high': 'Alto',
    'card.showDetails': 'Mostrar detalles',
    'card.hideDetails': 'Ocultar detalles',
    'card.scoreBreakdown': 'Desglose de puntuación',
    'card.deadline': 'Fecha límite:',
    'card.tags': 'Etiquetas:',
    'card.urgent': '(¡Urgente!)',
    'card.applyNow': '¡Solicitar ahora!',
    'card.viewDetails': 'Ver detalles',
    'card.learnMore': 'Saber más',
    
    // Funding Ranges
    'funding.over100k': 'Más de 100.000€',
    'funding.50to100k': '50.000€ - 100.000€',
    'funding.25to50k': '25.000€ - 50.000€',
    'funding.10to25k': '10.000€ - 25.000€',
    'funding.under10k': 'Menos de 10.000€',
    'funding.allRanges': 'Todos los rangos',
    'funding.notSpecified': 'No especificado',
    'funding.onRequest': 'Bajo consulta',
    'funding.up_to': 'hasta {amount}€',
    'funding.from': 'desde {amount}€',
    
    // Loading & Errors
    'loading.searching': 'Búsqueda inteligente de programas en curso...',
    'loading.analyzing': 'Analizando tus datos con sistema de puntuación avanzado',
    'error.loadingPrograms': 'Error al cargar los programas',
    'error.tryAgain': 'Intentar de nuevo',
    
    // New Layout Elements
    'results.topRecommendations': 'Principales recomendaciones para ti',
    'results.allPrograms': 'Todos los programas',
    'results.foundPrograms': 'Programas encontrados',
    'results.programsFound': 'programas encontrados',
    'results.sortedByRelevance': 'Ordenado por relevancia para tu explotación',
    'results.highlyRelevant': 'Muy relevante',
    'results.stillAvailable': 'Aún disponible',
    'results.avgRelevance': 'Ø Relevancia',
    'card.topMatch1': '#1 Mejor coincidencia',
    'card.veryGood2': '#2 Muy bueno',
    'card.recommendation3': '#3 Recomendación',
    
    // Ampel (Traffic Light) System
    'ampel.title': '🚦 Semáforo de Esfuerzo',
    'ampel.filterAll': 'Todos',
    'ampel.filterGreen': 'Rápido',
    'ampel.filterYellow': 'Medio',
    'ampel.filterOrange': 'Complejo',
    'ampel.filterRed': 'Muy complejo',
    'ampel.sortROI': 'Mejor ROI ↓',
    'ampel.sortEffort': 'Menos esfuerzo ↑',
    'ampel.sortDeadline': 'Más urgente ↑',
    'ampel.topRecommendations': 'RECOMENDACIONES TOP',
    'ampel.urgent': 'Urgente',
    'ampel.avgROI': 'Ø ROI',
    'ampel.quickStats': 'Vista rápida',
    'ampel.effortLow': 'Poco esfuerzo',
    'ampel.effortMedium': 'Esfuerzo medio',
    'ampel.effortHigh': 'Mucho esfuerzo',
    'ampel.effortVeryHigh': 'Esfuerzo muy alto',
    
    // Enhanced Program Card (Spanish)
    'card.pages': 'páginas',
    'card.documents': 'documentos',  
    'card.documents_count': 'piezas',
    'card.form': 'formulario',
    'card.complexity.simple': 'Simple',
    'card.complexity.medium': 'Medio', 
    'card.complexity.complex': 'Complejo',
    'card.relevance.perfect': '⭐ Perfectamente relevante',
    'card.relevance.high': '⭐ Muy relevante', 
    'card.relevance.good': '✓ Relevante',
    'card.relevance.limited': '⚠️ Parcialmente relevante',
    'card.of': 'de', // für "11 de 22"
    'card.optimal': 'Óptimo',
    'card.good': 'Bueno', 
    'card.check': 'Verificar'
  },
  
  it: {
    // Homepage
    welcome: "Benvenuto in",
    subtitle: "La piattaforma AI che rivoluziona la tua azienda",
    startButton: "Inizia ora",
    capabilities: "Quello che Centeo rende possibile:",
    liquidity: "Liquidità in 48 ore",
    partnership: "Partnership equa",
    investment: "Investimento attraente",
    
    // Hero Section
    heroTitle: "Finanziamento PAC reso facile",
    heroSubtitle: "Trova in 3 minuti i programmi di sostegno UE adatti alla tua azienda.",
    heroSubtitleBold: "Basato su AI, veloce, affidabile.",
    
    // Stats
    statFunding: "Trovato",
    statFarmers: "Agricoltori",
    statProcessing: "Elaborazione",
    
    // Process
    processTitle: "È così semplice",
    step1Title: "Descrivi azienda",
    step1Text: "Questionario di 3 minuti",
    step2Title: "AI analizza",
    step2Text: "Trova programmi adatti",
    step3Title: "Ricevi risultati",
    step3Text: "Disponibile subito",
    
    // Pricing
    pricingTitle: "Analisi unica",
    pricingBenefit1: "Tutti i programmi UE adatti",
    pricingBenefit2: "Analisi basata su AI",
    pricingBenefit3: "Risultati immediati",
    pricingBenefit4: "Garanzia rimborso",
    pricingButton: "🚀 Inizia ora",
    
    // Form Header
    farmDataTitle: "Trova il tuo finanziamento PAC",
    farmDataSubtitle: "Rispondi ad alcune domande sulla tua azienda e troveremo i programmi di sostegno UE adatti a te.",
    yourResults: "I tuoi programmi di finanziamento personalizzati",
    
    // StartScreen
    startTitle: "Qual è il tuo obiettivo oggi?",
    annualButton: "Assicurare i premi annuali",
    projectButton: "Finanziare un nuovo progetto",
    
    // FarmDataForm
    projectTitle: "Assistente in 3 domande per il tuo progetto",
    q1: "Dove si trova la tua azienda?",
    country: "Paese",
    region: "Regione/Provincia",
    q2: "Qual è il tuo settore principale?",
    q2Options: ["Agricoltura", "Latticini", "Avicoltura", "Viticoltura", "Altro"],
    q3: "Qual è il tuo obiettivo più importante?",
    q3Options: ["Investire e crescere", "Diventare più sostenibile", "Digitalizzare"],
    submitButton: "Trova finanziamenti",
    select: "Seleziona",
    
    // Form fields
    'form.country': 'In quale paese gestisci la tua azienda?',
    'form.farmType': 'Che tipo di azienda è?',
    'form.farmSize': 'Quanto è grande la tua azienda? (ettari)',
    'form.minFunding': 'Importo minimo di finanziamento (€)',
    'form.age': 'La tua età (per programmi giovani agricoltori)',
    'form.urgency': 'Quanto urgente hai bisogno del finanziamento?',
    'form.interests': 'Cosa ti interessa? (Selezione multipla)',
    'form.organic': 'La mia azienda è certificata biologica o sto pianificando la conversione',
    'form.findPrograms': 'Trova programmi di sostegno adatti',
    'form.selectCountry': 'Seleziona paese',
    'form.selectFarmType': 'Seleziona tipo di azienda',
    'form.selectUrgency': 'Seleziona urgenza',
    
    // Farm types
    'farmType.dairy': 'Caseario',
    'farmType.crops': 'Colture',
    'farmType.mixed': 'Misto',
    'farmType.organic': 'Biologico',
    'farmType.livestock': 'Allevamento',
    'farmType.other': 'Altri',
    
    // Categories
    'category.innovation': 'Innovazione',
    'category.sustainability': 'Sostenibilità',
    'category.digital': 'Digitalizzazione',
    'category.climate': 'Protezione climatica',
    'category.animalWelfare': 'Benessere animale',
    'category.energy': 'Energia',
    
    // Errors
    'error.countryRequired': 'Il paese è obbligatorio',
    'error.farmTypeRequired': 'Il tipo di azienda è obbligatorio',
    'error.farmSizeRequired': 'La dimensione dell\'azienda deve essere maggiore di 0',
    
    // Navigation
    backToHome: "← Torna alla homepage",
    backToForm: "← Torna al modulo",
    
    // Payment
    'payment.title': 'Quasi fatto!',
    'payment.subtitle': 'Paga una volta 9,90€ e ricevi immediatamente i tuoi programmi di finanziamento personalizzati.',
    'payment.amount': '9,90€',
    'payment.buttonText': 'Paga 9,90€ ora',
    'payment.emailPlaceholder': 'tua@email.it',
    'payment.analysisFor': 'La tua analisi per',
    'payment.country': 'Paese',
    'payment.farmType': 'Tipo di azienda',
    'payment.goal': 'Obiettivo',
    'payment.region': 'Regione',
    'payment.serviceName': 'Analisi di Finanziamento Centeo',
    'payment.total': 'Totale',
    'payment.whatYouGet': 'Quello che ricevi',
    'payment.benefit1': 'Programmi di finanziamento personalizzati per la tua azienda',
    'payment.benefit2': 'Importi stimati di finanziamento e tassi di successo',
    'payment.benefit3': 'Scadenze e documenti richiesti',
    'payment.benefit4': 'Garanzia di soddisfazione di 30 giorni',
    'payment.processing': 'Elaborazione...',
    'payment.securityInfo': '🔒 Pagamento sicuro via Stripe • 💳 Tutte le carte accettate • 🛡️ Crittografia SSL',
    'payment.backButton': 'Torna all\'inserimento',
    
    // Early Access Banner
    'earlyAccess.title': 'Prossimamente: Prefinanziamento dei vostri aiuti agricoli UE',
    'earlyAccess.subtitle': 'Stiamo lavorando a una soluzione per rendere liquidi i vostri diritti di aiuto prima del pagamento.',
    'earlyAccess.emailPlaceholder': 'E-Mail',
    'earlyAccess.button': 'Informare',
    'earlyAccess.submitting': '...',
    'earlyAccess.thankYou': 'Grazie – vi contatteremo!',
    'earlyAccess.error': 'Errore nella registrazione. Per favore, riprovate.',
    
    // Program Filter
    'filter.title': '🔍 Trova programmi di sostegno',
    'filter.country': 'Paese:',
    'filter.allCountries': 'Tutti i paesi',
    'filter.region': 'Regione:',
    'filter.allRegions': 'Tutte le regioni',
    'filter.farmType': 'Tipo di azienda:',
    'filter.allFarmTypes': 'Tutti i tipi',
    'filter.farmSize': 'Dimensione azienda (ettari):',
    'filter.farmSizePlaceholder': 'es. 100',
    'filter.categories': 'Categorie:',
    'filter.minFunding': 'Finanziamento minimo (€):',
    'filter.minFundingPlaceholder': 'es. 10000',
    'filter.searchButton': '🔍 Cerca programmi',
    'filter.searching': '🔍 Ricerca in corso...',
    'filter.error': '❌ Errore:',
    
    // Enhanced Filter & Scoring (NEW)
    'filter.searchPlaceholder': 'Ricerca intelligente (con correzione errori)...',
    'filter.relevance': 'Rilevanza',
    'filter.funding': 'Finanziamento',
    'filter.deadline': 'Scadenza',
    'filter.score': 'Punteggio',
    'filter.fundingRange': 'Fascia di finanziamento',
    'filter.minRelevance': 'Rilevanza minima',
    'filter.reset': '🔄 Ripristina',
    'filter.advanced': '🔧 Filtri avanzati',
    
    // Results
    'results.title': 'I tuoi programmi di finanziamento ottimizzati',
    'results.subtitle': 'programmi con punteggio intelligente',
    'results.averageRelevance': '⭐ Ø {score}% Rilevanza',
    'results.highRelevance': '🎯 {count} molto rilevanti',
    'results.goodRelevance': '✅ {count} adatti',
    'results.noResults': 'Nessun risultato trovato',
    'results.noResultsText': 'Nessun programma soddisfa i criteri di filtro attuali. Prova a rilassare i filtri o ripristinarli.',
    
    // Program Card
    'card.topMatch': 'Migliore corrispondenza',
    'card.highlyRecommended': 'Altamente raccomandato',
    'card.verysuitable': 'Molto adatto',
    'card.suitable': 'Adatto',
    'card.conditionally': 'Condizionatamente adatto',
    'card.lesssuitable': 'Meno adatto',
    'card.relevance': 'Rilevanza',
    'card.effort': 'Sforzo',
    'card.benefit': 'Beneficio',
    'card.analysis': 'Analisi Sforzo vs. Beneficio',
    'card.funding': 'Volume di finanziamento',
    'card.rating.optimal': 'Ottimale',
    'card.rating.good': 'Buono',
    'card.rating.check': 'Verificare',
    'card.effort.low': 'Basso',
    'card.effort.medium': 'Medio',
    'card.effort.high': 'Alto',
    'card.showDetails': 'Mostra dettagli',
    'card.hideDetails': 'Nascondi dettagli',
    'card.scoreBreakdown': 'Ripartizione del punteggio',
    'card.deadline': 'Scadenza:',
    'card.tags': 'Tag:',
    'card.urgent': '(Urgente!)',
    'card.applyNow': 'Candidati ora!',
    'card.viewDetails': 'Vedi dettagli',
    'card.learnMore': 'Scopri di più',
    
    // Funding Ranges
    'funding.over100k': 'Oltre 100.000€',
    'funding.50to100k': '50.000€ - 100.000€',
    'funding.25to50k': '25.000€ - 50.000€',
    'funding.10to25k': '10.000€ - 25.000€',
    'funding.under10k': 'Sotto 10.000€',
    'funding.allRanges': 'Tutte le fasce',
    'funding.notSpecified': 'Non specificato',
    'funding.onRequest': 'Su richiesta',
    'funding.up_to': 'fino a {amount}€',
    'funding.from': 'da {amount}€',
    
    // Loading & Errors
    'loading.searching': 'Ricerca intelligente di programmi in corso...',
    'loading.analyzing': 'Analizzando i tuoi dati con sistema di punteggio avanzato',
    'error.loadingPrograms': 'Errore nel caricamento dei programmi',
    'error.tryAgain': 'Riprova',
    
    // New Layout Elements
    'results.topRecommendations': 'Migliori raccomandazioni per te',
    'results.allPrograms': 'Tutti i programmi',
    'results.foundPrograms': 'Programmi trovati',
    'results.programsFound': 'programmi trovati',
    'results.sortedByRelevance': 'Ordinato per rilevanza per la tua azienda',
    'results.highlyRelevant': 'Molto rilevante',
    'results.stillAvailable': 'Ancora disponibile',
    'results.avgRelevance': 'Ø Rilevanza',
    'card.topMatch1': '#1 Migliore corrispondenza',
    'card.veryGood2': '#2 Molto buono',
    'card.recommendation3': '#3 Raccomandazione',
    
    // Ampel (Traffic Light) System
    'ampel.title': '🚦 Semaforo dello Sforzo',
    'ampel.filterAll': 'Tutti',
    'ampel.filterGreen': 'Veloce',
    'ampel.filterYellow': 'Medio',
    'ampel.filterOrange': 'Impegnativo',
    'ampel.filterRed': 'Molto complesso',
    'ampel.sortROI': 'Miglior ROI ↓',
    'ampel.sortEffort': 'Meno sforzo ↑',
    'ampel.sortDeadline': 'Più urgente ↑',
    'ampel.topRecommendations': 'RACCOMANDAZIONI TOP',
    'ampel.urgent': 'Urgente',
    'ampel.avgROI': 'Ø ROI',
    'ampel.quickStats': 'Panoramica rapida',
    'ampel.effortLow': 'Poco sforzo',
    'ampel.effortMedium': 'Sforzo medio',
    'ampel.effortHigh': 'Molto sforzo',
    'ampel.effortVeryHigh': 'Sforzo molto alto',
    
    // Enhanced Program Card (Italian)
    'card.pages': 'pagine',
    'card.documents': 'documenti',  
    'card.documents_count': 'pezzi',
    'card.form': 'modulo',
    'card.complexity.simple': 'Semplice',
    'card.complexity.medium': 'Medio', 
    'card.complexity.complex': 'Complesso',
    'card.relevance.perfect': '⭐ Perfettamente rilevante',
    'card.relevance.high': '⭐ Molto rilevante', 
    'card.relevance.good': '✓ Rilevante',
    'card.relevance.limited': '⚠️ Parzialmente rilevante',
    'card.of': 'di', // für "11 di 22"
    'card.optimal': 'Ottimale',
    'card.good': 'Buono', 
    'card.check': 'Verificare',
    
    // PDF Export
    'pdf.title': 'CENTEO - Dettagli del Programma di Finanziamento',
    'pdf.generatedOn': 'Generato il',
    'pdf.evaluation': 'Valutazione',
    'pdf.relevanceScore': 'Punteggio di Rilevanza',
    'pdf.effort': 'Sforzo',
    'pdf.benefit': 'Beneficio',
    'pdf.basicInfo': 'Informazioni di Base',
    'pdf.carrier': 'Ente',
    'pdf.level': 'Livello',
    'pdf.type': 'Tipo',
    'pdf.farmTypes': 'Tipi di Azienda',
    'pdf.targetGroup': 'Gruppo Target',
    'pdf.financing': 'Finanziamento',
    'pdf.fundingVolume': 'Volume di Finanziamento',
    'pdf.fundingRate': 'Tasso di Finanziamento',
    'pdf.countries': 'Paesi',
    'pdf.rating': 'Valutazione',
    'pdf.applicationEffort': 'Sforzo di Applicazione',
    'pdf.form': 'Modulo',
    'pdf.pages': 'pagine',
    'pdf.documents': 'documenti',
    'pdf.pieces': 'pezzi',
    'pdf.complexity': 'Complessità',
    'pdf.simple': 'Semplice',
    'pdf.medium': 'Medio',
    'pdf.complex': 'Complesso',
    'pdf.timeline': 'Cronologia e Combinazioni',
    'pdf.deadline': 'Scadenza',
    'pdf.endOf2025': 'Fine 2025',
    'pdf.ongoing': 'In corso',
    'pdf.combinable': 'Combinabile',
    'pdf.programs': 'programmi',
    'pdf.combinability': 'Combinabilità',
    'pdf.moreInfo': 'Maggiori Informazioni',
    'pdf.footer': 'Creato con CENTEO - Il vostro partner per i finanziamenti agricoli UE',
    'pdf.disclaimer': 'Queste informazioni sono senza garanzia. Si prega di verificare le condizioni attuali presso l\'ente.',
    'pdf.allFarmTypes': 'Tutti i tipi di azienda',
    'pdf.euWide': 'In tutta l\'UE',
    'pdf.grant': 'Sovvenzione',
    'pdf.loan': 'Prestito',
    'pdf.tax': 'Vantaggio fiscale',
    'pdf.insurance': 'Aiuto assicurativo',
    'pdf.inKind': 'In natura',
    'pdf.farmers': 'Agricoltori',
    'pdf.youth': 'Giovani agricoltori',
    'pdf.women': 'Donne',
    'pdf.coop': 'Cooperative',
    'pdf.research': 'Ricerca',
    'pdf.button': 'PDF',
    'pdf.generating': '⏳'
  }
};
